/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/12/28
 * Time: 3:45 PM
 */
import SocketEditor from './components/quill/components/SocketEditor'
import QuillEditor from './components/quill/components/QuillEditor'

const components = [
  SocketEditor,
  QuillEditor
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  ...components
}



// WEBPACK FOOTER //
// ./src/index.js